/*
 * Copyright Innov'ATM all rights reserved. This software is the property of Innov'ATM and may not be used in any
 * manner except under a license agreement signed with Innov'ATM.
 */

import { Paper, ThemeProvider } from '@mui/material';
import { ConfirmOptions } from 'material-ui-confirm';
import React from 'react';
import { ToastOptions } from 'react-toastify';

import { lightTheme } from '../theme';

export const ONE_HOUR = 60 * 60 * 1000;
export const localTimeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000;

export const MOBILE_BREAKPOINT = 900;
export const EMPTY_ARRAY: any[] = [];

export enum Locales {
    'en' = 'en',
    'fr' = 'fr',
}

export const defaultLocale = Locales.en;

export const defaultIcaoIata: 'icao' | 'iata' = 'iata';

export const slotsOverlapErrorToastConfig: ToastOptions = {
    autoClose: false,
    closeButton: true,
    type: 'error' as const,
};

export const errorToastConfig: ToastOptions = {
    autoClose: 6000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'error' as const,
};

export const successToastConfig: ToastOptions = {
    autoClose: 4000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'success' as const,
};

export const infoToastConfig: ToastOptions = {
    autoClose: 3000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'dark' as const,
    toastId: 'info',
};

export const defaultConfirmProps: ConfirmOptions = {
    dialogProps: {
        disablePortal: true,
        PaperComponent: props => (
            <ThemeProvider theme={lightTheme}>
                <Paper {...props} />
            </ThemeProvider>
        ),
    },
    cancellationButtonProps: {
        color: 'primary',
        variant: 'contained',
        size: 'small',
    },
    confirmationButtonProps: {
        color: 'primary',
        variant: 'contained',
        size: 'small',
    },
};

export const passwordPolicy = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"|,.<>/?])\S{12,}$/;
